import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Videos from './pages/Videos';
import Team from './pages/Team';
import Pagamentos from './pages/Pagamentos';
import Configuracoes from './pages/Configuracoes';
import MinhaConta from './pages/MinhaConta';
import Layout from './components/Layout';
import { useAuth } from './context/AuthContext';
import MeusBonus from './pages/MeusBonus';
import Metas from './pages/Metas';
import Auditoria from './pages/Auditoria';

const PrivateRoute = ({ children, requiredRole, activeKey }) => {
  const { token, acesso } = useAuth();

  if (!token) return <Navigate to="/login" />;
  // Se o usuário não tiver a permissão, redireciona para a página inicial correta.
  if (requiredRole && !requiredRole.includes(acesso)) return <Navigate to="/" />;

  return <Layout activeKey={activeKey}>{children}</Layout>;
};

const HomeRedirect = () => {
  const { acesso } = useAuth();

  // Admin vai para o Dashboard.
  if (acesso === 'admin') return <Navigate to="/dashboard" />;

  // Gerente e Colaborador vão para a mesma página.
  return <Navigate to="/meus-bonus" />;
};

function App() {
  // --- INICIALIZAÇÃO DO TEMA WHITE LABEL ---
  useEffect(() => {
    const root = document.documentElement;
    
    // Mapeamento das variáveis do .env para as variáveis do CSS
    const themeMap = {
      '--brand-primary': process.env.REACT_APP_PRIMARY_COLOR,
      '--brand-secondary': process.env.REACT_APP_SECONDARY_COLOR,
      '--brand-accent': process.env.REACT_APP_ACCENT_COLOR,
      '--brand-bg-light': process.env.REACT_APP_BG_COLOR,
    };

    const hexToRgb = (hex) => {
      if (!hex) return null;
      hex = hex.replace(/^#/, '');
      if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
      }
      const num = parseInt(hex, 16);
      return num ? `${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}` : null;
    };

    // Aplica cada cor se ela estiver definida no .env
    Object.entries(themeMap).forEach(([key, value]) => {
      if (value) {
        root.style.setProperty(key, value);
        const rgb = hexToRgb(value);
        if (rgb) {
          root.style.setProperty(`${key}-rgb`, rgb);
        }
      }
    });
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* Rotas que SÓ o ADMIN pode acessar */}
      <Route path="/dashboard" element={<PrivateRoute requiredRole={['admin']} activeKey="dashboard"><Dashboard /></PrivateRoute>} />
      <Route path="/videos" element={<PrivateRoute requiredRole={['admin']} activeKey="videos"><Videos /></PrivateRoute>} />
      <Route path="/equipe" element={<PrivateRoute requiredRole={['admin']} activeKey="equipe"><Team /></PrivateRoute>} />
      <Route path="/pagamentos" element={<PrivateRoute requiredRole={['admin']} activeKey="pagamentos"><Pagamentos /></PrivateRoute>} />
      <Route path="/configuracoes" element={<PrivateRoute requiredRole={['admin']} activeKey="configuracoes"><Configuracoes /></PrivateRoute>} />
      <Route path="/auditoria" element={<PrivateRoute requiredRole={['admin']} activeKey="auditoria"><Auditoria /></PrivateRoute>} />

      {/* Rotas que TODOS os usuários logados podem acessar */}
      <Route path="/meus-bonus" element={<PrivateRoute requiredRole={['colaborador', 'gerente', 'admin']} activeKey="meus-bonus"><MeusBonus /></PrivateRoute>} />
      <Route path="/minha-conta" element={<PrivateRoute requiredRole={['colaborador', 'gerente', 'admin']} activeKey="minha-conta"><MinhaConta /></PrivateRoute>} />
      <Route path="/metas" element={<PrivateRoute requiredRole={['colaborador', 'gerente', 'admin']} activeKey="metas"><Metas /></PrivateRoute>} />

      <Route path="/" element={<HomeRedirect />} />
    </Routes>
  );
}

export default App;